<template>
  <div
    v-outside-click="{
      exclude: [],
      handler: handleClose
    }"
    class="user-menu__container"
  >
    <div @click="toggleMenu">
      <slot></slot>
    </div>
    <section v-if="showMenu" class="user-menu">
      <HUserData />
      <template v-if="hasPermissionToGetChat">
        <HUserStatus
          :current-status="loggedStaff.status"
          :disabled="loading"
          @input="handleChangeStatus"
        />
      </template>
      <div v-if="showCertificationFeature" class="user-menu__certification">
        <hr class="user-menu__divider" />
        <WParagraph size="large" class="user-menu__certification__title">
          Certificado digital
        </WParagraph>
        <HCertification
          v-if="showCertificationInput"
          mini
          @close="handleClose"
        />
        <div v-else class="user-menu__certification--active">
          <WIcon icon="icCheckOutlined" size="medium" />
          Sessão ativa
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import { WIcon, WParagraph } from '@alice-health/wonderland-vue'
import { mapGetters, mapState } from 'vuex'

import { CertificationStatus } from '../../../constants/certificate.constant'
import HCertification from '../../certification/organisms/HCertification.vue'
import { HUserData, HUserStatus } from '../atoms'

export default {
  components: {
    HCertification,
    HUserData,
    HUserStatus,
    WIcon,
    WParagraph
  },
  inject: ['notify'],
  props: {
    certificationState: {
      type: String,
      default: CertificationStatus.INACTIVE
    }
  },
  data() {
    return {
      showMenu: false,
      loading: false
    }
  },
  computed: {
    ...mapGetters('user', ['user', 'hasPermissionToGetChat']),
    ...mapGetters('channel/staff', ['loggedStaff']),
    ...mapState('permissions', {
      showCertificationFeature: state => state.user.certificate.view
    }),
    showCertificationInput() {
      return this.certificationState !== CertificationStatus.ACTIVE
    }
  },
  methods: {
    toggleMenu() {
      this.showMenu = !this.showMenu
    },
    handleClose() {
      this.showMenu = false
    },
    async handleChangeStatus(status) {
      this.loading = true
      const result = await this.$store.dispatch(
        'channel/staff/setLoggedStaffStatus',
        status
      )
      if (result)
        this.notify({
          description: 'Status atualizado',
          icon: 'icCheckOutlined',
          duration: 2000
        })
      this.loading = false
    }
  }
}
</script>
<style lang="scss" scoped>
.user-menu {
  background: var(--gl-color-shades-white);
  width: max-content;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.08);
  border: var(--gl-border-width-xs) solid var(--gl-color-shades-gray-20);
  border-radius: var(--gl-border-radius-sm);
  padding: var(--gl-spacing-06);
  position: absolute;
  left: 49px;
  bottom: -50px;
  z-index: 25;

  &__container {
    position: relative;
  }

  &__certification {
    &__title {
      margin-bottom: var(--gl-spacing-04);
      color: var(--gl-color-shades-gray-100);
      font-size: var(--gl-font-size-md);
      line-height: var(--gl-line-height-xs);
      font-weight: var(--gl-font-weight-regular);
    }
    &--active {
      display: flex;
      align-items: center;
      color: var(--gl-color-shades-turquoise-70);
      gap: var(--gl-spacing-02);
      line-height: var(--gl-line-height-xxxs);
    }
  }

  &__divider {
    margin: var(--gl-spacing-06) calc(var(--gl-spacing-06) * -1);
    background-color: var(--gl-color-shades-gray-10);
    opacity: 1;
  }
}
</style>
